// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"Title_titleWrapper__zDdAC","sectionTitle":"Title_sectionTitle__pA7nn","horizontalSectionDivider":"Title_horizontalSectionDivider__qrKpf"};